import React, { memo } from 'react';
import './ticketDetail.style';
import { Grid } from '@mui/material';
import { NOT_APPLICABLE } from '../../../constants/originalState';

export interface IAssignmentErrorProps {
  infoTicket: any,
  configTracking: any,
  locale: any
};

const PcBreakFix = (props: IAssignmentErrorProps) => {
  const {
    infoTicket: { variables: variableInfo, subCategory },
    locale,
    configTracking
  } = props;

  const {
    asset,
    delivery_address: deliveryAddress,
    new_asset: newAsset,
    delivery_ref: deliveryRef,
  } = variableInfo;

  const modelName = asset?.model;
  const serialNumber = asset?.serial_number;
  const newModelName = newAsset?.model;
  const newSerialNumber = newAsset?.serial_number;

  return (
    <Grid container>
      <Grid item xs={12}>
        <p className='ttl-col-desc'>{locale?.moreDetails}</p>
        <p className='value-info' id="lbl-pcbreakfix-subcategory">{subCategory || NOT_APPLICABLE}</p>
      </Grid>
      <Grid item xs={12} md={6} className='pr-20'>
        <p className='ttl-col-desc'>{locale?.brokenDevice}</p>
        <p className='value-info' id="lbl-pcbreakfix-serialnumber">
          <strong>{locale?.serialNumber}</strong>: {serialNumber || NOT_APPLICABLE}
        </p>
        <p className='value-info' id="lbl-pcbreakfix-modelname">
          <strong>{locale?.modelName}</strong>: {modelName || NOT_APPLICABLE}
        </p>
      </Grid>
      <Grid item xs={12} md={6}>
        <p className='ttl-col-desc'>{locale?.replacementDevice}</p>
        {!!newAsset ? (
          <>
            <p className='value-info' id="lbl-pcbreakfix-newserialnumber">
              <strong>{locale?.serialNumber}</strong>: {newSerialNumber}
            </p>
            <p className='value-info' id="lbl-pcbreakfix-newmodelname">
              <strong>{locale?.modelName}</strong>: {newModelName}
            </p>
          </>
        ) : (
          <p className='value-info'>{locale?.reservationError}</p>
        )}
      </Grid>
      <Grid item xs={12} md={6} className='pr-20'>
        <p className='ttl-col-desc'>{locale?.shippingAddress}</p>
        <p className='value-info' id="lbl-pcbreakfix-deliveryaddress">{deliveryAddress}</p>
      </Grid>
      <Grid item xs={12} md={6}>
        <p className='ttl-col-desc'>{locale?.trackingInfo}</p>
        <p className='value-info' id="lbl-pcbreakfix-trackinginfo">{configTracking(deliveryRef)}</p>
      </Grid>
    </Grid>
  );
};

export default memo(PcBreakFix);
